import { defaultAttributes } from '../styles';
var colors = defaultAttributes.colors; // MUI component overrides:

var overrides = {
  MuiFormLabel: {
    focused: {},
    root: {
      '&$focused': {
        color: colors.adminBlue
      }
    }
  },
  MuiPickersClock: {
    pin: {
      backgroundColor: colors.nearBlack
    }
  },
  MuiPickersClockPointer: {
    thumb: {
      borderColor: colors.nearBlack
    },
    pointer: {
      backgroundColor: colors.nearBlack
    }
  },
  MuiPickersDay: {
    day: {
      color: colors.nearBlack
    },
    isSelected: {
      backgroundColor: colors.nearBlack,
      '&:hover': {
        backgroundColor: colors.nearBlack
      }
    },
    current: {
      color: colors.adminBlue
    }
  },
  MuiPickersModal: {
    dialog: {
      borderRadius: 0
    },
    dialogAction: {
      borderRadius: 0,
      color: colors.nearBlack
    }
  },
  MuiPickersToolbar: {
    toolbar: {
      backgroundColor: colors.nearBlack
    }
  },
  MuiPickersToolbarButton: {
    toolbarBtn: {
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontSize: 60,
      fontWeight: 300
    }
  }
};
export default overrides;